// extracted by mini-css-extract-plugin
module.exports = {"share-link":"shareLink_share-link__vS7DG"};